import { Injectable } from '@angular/core';
import { SimpleConfigBaseFilter } from 'gung-list';
import { MetadataService, Product } from 'gung-standard';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ProductExternalSubCategoryFilterService extends SimpleConfigBaseFilter<Product> {
  private externalCategoriesCache: any = {};

  constructor(
    protected metadataService: MetadataService,
    protected translateService: TranslateService
  ) {
    super();
  }
  SEGMENT: string = 'ProductExternalSubCategory';
  SEGMENT_META: string = 'ExternalSubCategory';

  getName(): string {
    return 'EXTERNAL_SUB_CATEGORY';
  }
  getOptionIds(item: Product): string[] {
    const currentLang = this.translateService.currentLang;
    if (!!item.extra.i18n[currentLang].ProductExternalSubCategory) {
      return [item.extra.i18n[currentLang].ProductExternalSubCategory];
    } else if (currentLang !== 'en' && !!item.extra.i18n['en'].ProductExternalSubCategory) {
      return [item.extra.i18n['en'].ProductExternalSubCategory];
    } else {
      return [];
    }

    if (!!item.extra.hlPimProduct && !!item.extra.hlPimProduct[this.SEGMENT]) {
      const value = item.extra.hlPimProduct[this.SEGMENT];

      let productExternalCategoryIds: string[] = [];
      if (Array.isArray(value)) {
        productExternalCategoryIds = value;
      } else {
        productExternalCategoryIds = [value];
      }

      const result = productExternalCategoryIds.map(key => {
        if (this.externalCategoriesCache[key]) return this.externalCategoriesCache[key];

        const productExternalCategoryValue = this.getI18nProductExternalCategory(item, key);

        if (!!productExternalCategoryValue) {
          this.externalCategoriesCache[key] = productExternalCategoryValue;
          return productExternalCategoryValue;
        }
      });

      return result;
    }

    return [];
  }

  getOptionName(key: string): string {
    return key;
  }

  private getI18nProductExternalCategory(item: Product, key: string): string {
    // in case not find a product external category for the selected language then use the default

    let selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';

    if (selectedLanguage === 'en') {
      selectedLanguage = 'en-GB';
    }

    if (!!item.extra.i18n) {
      if (
        !!item.extra.i18n[selectedLanguage] &&
        !!item.extra.i18n[selectedLanguage][this.SEGMENT_META] &&
        !!item.extra.i18n[selectedLanguage][this.SEGMENT_META][key]
      ) {
        return item.extra.i18n[selectedLanguage][this.SEGMENT_META][key];
      }

      const defaultLanguage = 'en';

      if (
        !!item.extra.i18n[defaultLanguage] &&
        !!item.extra.i18n[defaultLanguage][this.SEGMENT_META] &&
        !!item.extra.i18n[defaultLanguage][this.SEGMENT_META][key]
      ) {
        return item.extra.i18n[defaultLanguage][this.SEGMENT_META][key];
      }
    }

    return key;
  }
}
